<div class="right-side p-5">
<div class="attendance-header d-flex justify-content-between align-items-center">

  <!-- Left Content -->
  <div>
    <h2 class="fw-bold mb-1 header-title">
      Update MSME Attendance
    </h2>



    <div class="event-name">
      <i class="bi bi-calendar-event me-1"></i>
      {{ EventId }}
    </div>
  </div>

  <!-- Close Button -->
  <button
    mat-icon-button
    mat-dialog-close
    class="close-btn"
  >
    <mat-icon>close</mat-icon>
  </button>

</div>
  <div class="section">

    <!-- 🔘 Top Bar -->
    <div class="d-flex justify-content-between align-items-center mb-3">






      <!-- 🔍 Search -->
      <div class="d-flex align-items-center w-75">

        <mat-form-field appearance="outline" class="w-75 me-2">
          <mat-label>Search...</mat-label>
          <input
            matInput
            [(ngModel)]="pagination.searchTerm"
            (keyup.enter)="loadData()" />
        </mat-form-field>

        <!-- Search Button -->
        <button class="btn btn-outline-secondary me-2" (click)="loadData()">
          <i class="bi bi-search"></i>
        </button>

        <!-- Reset Button -->
        <button class="btn btn-outline-secondary" (click)="resetFilters()">
          <i class="bi bi-arrow-clockwise"></i>
        </button>

      </div>

      <!-- ✏️ Action Button -->
<div class="d-flex gap-2 mb-3">

  <!-- ✏️ Update Attendance -->

  <!-- 📊 Export Excel -->
  <button mat-raised-button color="accent" (click)="exportToExcel()">
    <mat-icon>download</mat-icon>
    Export to Excel
  </button>

</div>

    </div>

<div class="table-responsive">
  <table class="table table-bordered table-striped text-center align-middle">

    <thead class="table-dark">
      <tr>
        <th>Sr No</th>
        <th>Event ID</th>
        <th>Event Name</th>
        <th>Total Enroll Msme</th>
        <th>Old Attendance </th>
        <th> Revised Attendance </th>
        <th>Updated date & Time </th>
       <th>Updated Attendance By </th>
    
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let item of dataSource; let i = index"
          [class.table-warning]="item.Attended === item.TotalCapacity">

        <td>{{ i + 1 }}</td>
        <td>{{ item.EventId }}</td>
        <td>{{ item.EventName }}</td>
<td>
  <a href="javascript:void(0)"
     (click)="openMsmePopup(item, 'total')"
    >
    {{ item.TotalCapacity }}
  </a>
</td>

<td>
  <a href="javascript:void(0)"
     (click)="openMsmePopup(item, 'old')"
   >
    {{ item.OldCheckedCount }}
  </a>
</td>

<td>
  <a href="javascript:void(0)"
     (click)="openMsmePopup(item, 'new')"
   >
    {{ item.NewCheckedCount }}
  </a>
</td>
<td>
{{ item.CreatedDate | date:'dd/MM/yyyy HH:mm' }}

 
</td>
    
    <td>
{{ item.CreatedByName }}

 
</td>


 

      </tr>
    </tbody>

  </table>
</div>
    <mat-paginator [length]="totalRecords"
                   [pageSize]="pagination.pageSize"
                   [pageIndex]="pagination.pageNumber - 1"
                   [pageSizeOptions]="[5, 10, 20, 50]"
                   (page)="onPageChange($event)">
    </mat-paginator>
    <!-- ❌ No Data -->
    <ng-template #noData>
      <div class="text-center p-4 text-muted">
        No attendance data available
      </div>
    </ng-template>

  </div>
</div>



<div class="modal fade" id="msmeModal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header">
        <h5 class="modal-title fw-bold">MSME List</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">

        <!-- 🔍 Material Search -->
  

        <!-- 📊 Table (simple *ngFor) -->
        <div class="table-responsive">
          <table class="table table-hover table-bordered align-middle mat-elevation-z2">
            <thead class="table-light">
              <tr>
                <th>Participant Name</th>
                <th>Mobile</th>
                <th>Enterprise</th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let m of msmeList">
                <td class="fw-semibold">{{ m.ParticipantName }}</td>
                <td>{{ m.MobileNumber }}</td>
                <td>{{ m.NameOfEnterprise }}</td>
              </tr>

              <tr *ngIf="msmeList.length === 0">
                <td colspan="3" class="text-center text-muted py-3">
                  No data found
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 📄 Material Pagination -->
        <mat-paginator
          [length]="totalRecordsmsme"
          [pageSize]="pageSize"
            [pageSize]="10"
          showFirstLastButtons
          (page)="onPageChangemsme($event)">
        </mat-paginator>

      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button class="btn btn-primary" data-bs-dismiss="modal">
          Close
        </button>
      </div>

    </div>
  </div>
</div>
